import angular from "angular";
import { MachineBankConfig } from "./machineBank";
import { vsModuleName as machineComponentsModuleName } from "../components/module";
import { moduleName as recordsModuleName } from "../../../records";
import { MachineZoneConfig } from "./machineZone";
import { MachineAreaConfig } from "./machineArea";
import { MachineManufacturerConfig } from "./machineManufacturer";
import { MachineModelConfig } from "./machineModel";
import { MachineModelTypeConfig } from "./machineModelType";
import { MachineDenominationConfig } from "./machineDenomination";
import { MachineThemeConfig } from "./machineTheme";
import { IViewVersionConfig } from "./iViewVersion";
import { MachineGameCategoryConfig } from "./machineGameCategory";
import { ProgressiveTypeConfig } from "./progressiveType";
import { MachineChangeChildStateProviderConfig } from "./machineChangeConfig";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import { MachineConfiguration } from "./machineConfiguration";
import { ProgressiveDefinition } from "./progressiveDefinition";
import { Machine } from "./machine";
import { MachineGameConfiguration } from "./machineGameConfiguration";
import { ProgressiveDefinitionGame } from "./progressiveDefinitionGame";

export const vsModuleName = "SlotTrak.Machines.Config";
export default vsModuleName;

angular
  .module(vsModuleName, [
    machineComponentsModuleName,
    recordsModuleName,
    shareMachineModuleName,
  ])
  .config(MachineBankConfig)
  .config(MachineZoneConfig)
  .config(MachineAreaConfig)
  .config(MachineManufacturerConfig)
  .config(MachineModelConfig)
  .config(MachineModelTypeConfig)
  .config(MachineDenominationConfig)
  .config(MachineThemeConfig)
  .config(IViewVersionConfig)
  .config(MachineGameCategoryConfig)
  .config(ProgressiveTypeConfig)
  .config(MachineChangeChildStateProviderConfig)
  .config(MachineConfiguration)
  .config(Machine)
  .config(MachineGameConfiguration)
  .config(ProgressiveDefinition)
  .config(ProgressiveDefinitionGame);
